import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';
import { dateValidation } from '../../../../../util/yupUtils';
import { membershipCategoriesList } from '../../../../../constants/membershipConstants';

const fields = [
  {
    colSpan: 2,
    name: 'millName',
    type: 'text',
    isRequired: true,
    label: 'Name of the Mill',
  },
  {
    colSpan: 1,
    name: 'millEmail',
    type: 'email',
    label: 'Email Address',
  },
  {
    colSpan: 1,
    name: 'millPhoneNo',
    type: 'text',
    label: 'Phone',
  },
  {
    colSpan: 1,
    name: 'website',
    type: 'text',
    label: 'Website Address',
  },

  {
    fieldType: 'date',
    colSpan: 1,
    name: 'dateOfEstablishment',
    label: 'Establishment Date',
  },
  {
    colSpan: 1,
    name: 'yearOfOperation',
    type: 'text',
    label: 'Year of Operation',
  },
  {
    fieldType: 'date',
    colSpan: 1,
    name: 'membershipDate',
    label: 'Membership Date',
  },
  {
    fieldType: 'select',
    colSpan: 1,
    label: 'Membership Category',
    name: 'membershipCategory',
    choices: membershipCategoriesList,
  },
  {
    fieldType: 'date',
    colSpan: 1,
    name: 'boardApprovalDate',
    label: 'Board Approval Date',
  },
];

export const millInformationFieldsValidation = {
  [fields[0].name]: yup.string().required().label(fields[0].label),
  [fields[1].name]: yup.string().email().label(fields[1].label).nullable(),
  [fields[2].name]: yup.string().label(fields[2].label).nullable(),
  [fields[3].name]: yup.string().label(fields[3].label).nullable(),
  [fields[4].name]: dateValidation.label(fields[4].label),
  [fields[5].name]: yup.string().label(fields[5].label).nullable(),
  [fields[6].name]: dateValidation.label(fields[6].label),
};

const MillInformationSection = (props) => {
  return (
    <FormSection sectionName="Mill Information" sectionColumn={2} formFields={fields} {...props} />
  );
};

export default MillInformationSection;
